<div>
    <span fxFlex="auto"></span>

    <button (click)="login('google')" mat-raised-button aria-label="Google icon">
        <mat-icon svgIcon="google"></mat-icon>
        Login
    </button>

    <span fxFlex="auto"></span>
</div>